/**
 * General helper functions
 */


function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

String.prototype.replaceAll = function (find, replace) {
    var str = this;
    return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
};

// callback for vimeo
function embedVimeo(video) {
  document.getElementById('playerHeader').innerHTML = decodeURI(video.html);
}

(function($){
  var that = {};

  /**
   * growl error wrapper
   * @param message
   */
  that.growlerror = function (message) {
    $.growl.error($.extend({title: that.__('error')}, {message: that.__(message.message)}));
  };

  /**
   * growl notice wrapper
   * @param message
   */
  that.growlnotice = function (message) {
    $.growl.notice($.extend({message: that.__(message.message)}, {title: that.__('notice')}));
  };

  /**
   * growl warning wrapper
   * @param message
   */
  that.growlwarning = function (message) {
    $.growl.warning($.extend({message: that.__(message.message)}, {title: that.__('warning')}));
  };

  that.fixScrolldownLinks = function () {
    $('.scrolldown-wrapper a').each(function () {
      var href = $(this).attr("href");
      var elem = $(href);
      if (!elem.length) { // target doesnt exist
        var currentElem = $(this).parentsUntil("#content");
        if (currentElem.length) {
          currentElem = currentElem.get(currentElem.length - 1);
          var belowContent = $('#content > *').not("#scrollspy-menu");
          if (belowContent.length) {
            var index = belowContent.index(currentElem);
            index++;
            var newTarget;
            var foundNewId = false;
            while (index < belowContent.length) {
              newTarget = belowContent.get(index);
              if ($(newTarget).attr("id") !== "") {
                $(this).attr("href", "#" + $(newTarget).attr("id"));
                foundNewId = true;
                break;
              }
              index++;
            }
            if (!foundNewId) {
              $(this).parent().parent().detach();
            }
          }
        }
      }
    });
    $("#content").children();
  };

  /**
   * generate uuid
   * @returns {*}
   */
  that.uuid = function () {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }

    return s4() + s4();
  };

  /**
   * Checks for iponge, android, etc.
   */
  that.checkMobile = function () {
    var matches = navigator.userAgent.match(new RegExp('iPhone|Android|iPad|iPod|webOS|Lumia', 'i'));
    if (matches) {
      $(".hidden-mobile").remove(); // remove because iframe
      $("[data-elid]").removeAttr("data-elid");
    }
  };

  /**
   * Query vimeo to get thumbnail urls
   */
  that.setVimeoThumbnails = function () {
    $.each($(".vimeo"), function (key, value) {
      var id = $(value).attr("data-videoid");
      if (id) {
        var oembed_endpoint = 'https://vimeo.com/api/oembed';
        var video_url = 'https://vimeo.com/' + id;
        var url = oembed_endpoint + '.json?url=' + encodeURIComponent(video_url) + '&api=1';
        var xhr = $.ajax({
          url: url
        }, 'json');
        xhr.always(function (data) {
          var thumbUrl = data.thumbnail_url;
          $(value).attr("style", 'background-image: url(' + thumbUrl + ')');
        });
      }
    });
  };

  /**
   *
   * @param text
   */
  that.log = function(text) {
    if(getLibObject("config").debug) {
      console.info(text);
    }
  };

  /**
   * Randomize array element order in-place.
   * Using Durstenfeld shuffle algorithm.
   */
  that.shuffleArray = function(array) {
    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
    return array;
  };

  /**
   *
   * @param blogId
   * @param sessionId
   * @returns {string}
   */
  that.getRoomNameFromBlogIdAndSessionId = function(blogId, sessionId) {
    return "blog-" + blogId + "_session-" + sessionId;
  };

  that.wpautop = function(pee, br) {

    // source:
    // https://gist.github.com/ediamin/19ef0a4b0bff2dbfd7676c916d7dcd2a
    // https://github.com/andymantell/node-wpautop
    var _autop_newline_preservation_helper = function(matches) {
      return matches[0].replace( "\n", "<WPPreserveNewline />" );
    };

    if(typeof(br) === 'undefined') {
      br = true;
    }

    var pre_tags = {};
    if ( pee.trim() === '' ) {
      return '';
    }

    pee = pee + "\n"; // just to make things a little easier, pad the end
    if ( pee.indexOf( '<pre' ) > -1 ) {
      var pee_parts = pee.split( '</pre>' );
      var last_pee = pee_parts.pop();
      pee = '';
      pee_parts.forEach(function(pee_part, index) {
        var start = pee_part.indexOf( '<pre' );

        // Malformed html?
        if ( start === -1 ) {
          pee += pee_part;
          return;
        }

        var name = "<pre wp-pre-tag-" + index + "></pre>";
        pre_tags[name] = pee_part.substr( start ) + '</pre>';
        pee += pee_part.substr( 0, start ) + name;

      });

      pee += last_pee;
    }

    pee = pee.replace(/<br \/>\s*<br \/>/, "\n\n");

    // Space things out a little
    var allblocks = '(?:table|thead|tfoot|caption|col|colgroup|tbody|tr|td|th|div|dl|dd|dt|ul|ol|li|pre|form|map|area|blockquote|address|math|style|p|h[1-6]|hr|fieldset|legend|section|article|aside|hgroup|header|footer|nav|figure|figcaption|details|menu|summary)';
    pee = pee.replace( new RegExp('(<' + allblocks + '[^>]*>)', 'gmi'), "\n$1");
    pee = pee.replace( new RegExp('(</' + allblocks + '>)', 'gmi'), "$1\n\n");
    pee = pee.replace( /\r\n|\r/, "\n" ); // cross-platform newlines

    if ( pee.indexOf( '<option' ) > -1 ) {
      // no P/BR around option
      pee = pee.replace( /\s*<option'/gmi, '<option');
      pee = pee.replace( /<\/option>\s*/gmi, '</option>');
    }

    if ( pee.indexOf('</object>') > -1 ) {
      // no P/BR around param and embed
      pee = pee.replace( /(<object[^>]*>)\s*/gmi, '$1');
      pee = pee.replace( /\s*<\/object>/gmi, '</object>' );
      pee = pee.replace( /\s*(<\/?(?:param|embed)[^>]*>)\s*/gmi, '$1');
    }

    if ( pee.indexOf('<source') > -1 || pee.indexOf('<track') > -1 ) {
      // no P/BR around source and track
      pee = pee.replace( /([<\[](?:audio|video)[^>\]]*[>\]])\s*/gmi, '$1');
      pee = pee.replace( /\s*([<\[]\/(?:audio|video)[>\]])/gmi, '$1');
      pee = pee.replace( /\s*(<(?:source|track)[^>]*>)\s*/gmi, '$1');
    }

    pee = pee.replace(/\n\n+/gmi, "\n\n"); // take care of duplicates

    // make paragraphs, including one at the end
    var pees = pee.split(/\n\s*\n/);
    pee = '';
    pees.forEach(function(tinkle) {
      pee += '<p>' + tinkle.replace( /^\s+|\s+$/g, '' ) + "</p>\n";
    });

    pee = pee.replace(/<p>\s*<\/p>/gmi, ''); // under certain strange conditions it could create a P of entirely whitespace
    pee = pee.replace(/<p>([^<]+)<\/(div|address|form)>/gmi, "<p>$1</p></$2>");
    pee = pee.replace(new RegExp('<p>\s*(</?' + allblocks + '[^>]*>)\s*</p>', 'gmi'), "$1", pee); // don't pee all over a tag
    pee = pee.replace(/<p>(<li.+?)<\/p>/gmi, "$1"); // problem with nested lists
    pee = pee.replace(/<p><blockquote([^>]*)>/gmi, "<blockquote$1><p>");
    pee = pee.replace(/<\/blockquote><\/p>/gmi, '</p></blockquote>');
    pee = pee.replace(new RegExp('<p>\s*(</?' + allblocks + '[^>]*>)', 'gmi'), "$1");
    pee = pee.replace(new RegExp('(</?' + allblocks + '[^>]*>)\s*</p>', 'gmi'), "$1");

    if ( br ) {
      pee = pee.replace(/<(script|style)(?:.|\n)*?<\/\\1>/gmi, _autop_newline_preservation_helper); // /s modifier from php PCRE regexp replaced with (?:.|\n)
      pee = pee.replace(/(<br \/>)?\s*\n/gmi, "<br />\n"); // optionally make line breaks
      pee = pee.replace( '<WPPreserveNewline />', "\n" );
    }

    pee = pee.replace(new RegExp('(</?' + allblocks + '[^>]*>)\s*<br />', 'gmi'), "$1");
    pee = pee.replace(/<br \/>(\s*<\/?(?:p|li|div|dl|dd|dt|th|pre|td|ul|ol)[^>]*>)/gmi, '$1');
    pee = pee.replace(/\n<\/p>$/gmi, '</p>');

    if ( Object.keys(pre_tags).length ) {
      pee = pee.replace( new RegExp( Object.keys( pre_tags ).join( '|' ), "gi" ), function (matched) {
        return pre_tags[matched];
      });
    }

    return pee;
  };

  var weekdays_short = ['So','Mo','Di','Mi','Do','Fr','Sa','So'];

  /**
   *
   * @param date
   */
  that.getDateTimestampIso = function(date) {
    if(!date) {
      date = new Date();
    }
    return date.toISOString();
  };

  /**
   *
   * @param date
   */
  that.getDateTimestampUnix = function(date) {
    if(!date) {
      date = new Date();
    }
    return date.getTime()/1000;
  };

  /**
   *
   * @param date
   * @returns {string}
   */
  that.getDateTimestampFormated = function(date) {
    if(!date) {
      date = new Date();
    }
    return weekdays_short[parseInt(date.getDay())] + ". " +
        date.getDate() + "." + date.getMonth() + "." + ", " + date.getHours() + ":" + date.getMinutes() + " Uhr";
  };

  /**
   *
   * @param name
   * @returns {string}
   */
  that.getInitials = function(name) {
    if (name.indexOf(" (") !== -1) {
      var splitted = name.split(" (");
      name = splitted[0];
    }

    var names = name.split(' ');
    var initials = names[0].substring(0, 1).toUpperCase();

    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
  };

    /**
     * if setTimout gets a value that is higher (2^31-1) it will trigger immediately
     * @param number
     */
    that.limitNumberTo32BitSigned = function(number) {
        if (number > 0x6FFFFFFF) { //setTimeout limit is MAX_INT32=(2^31-1)
            return 0x6FFFFFFF;
        }
        return number;
    };

    /**
     * Reload page without cache (parameter = true)
     */
    that.reloadPage = function() {
        location.reload(true);
    };

  /**
   *
   * return translation if set, return param if not
   * @param text
   */
  that.__ = function(text) {
    if(getLibObject("config").language === 'en') {
      if(getLibObject('translations').en[text] !== undefined) {
        return getLibObject('translations').en[text];
      }
    }
    else {
      if(getLibObject('translations').de[text] !== undefined) {
        return getLibObject('translations').de[text];
      }
    }

    return text;
  };

  window.vrnetworld.helper = that;
})(jQuery);
